import { dataAnalyticsTitlesAndPath } from './routeTitleConnection';

export const dataAnalyticsCards = [
  {
    title: 'Active Tutors in a Month',
    path: dataAnalyticsTitlesAndPath.ACTIVE_TUTORS,
  },
  {
    title: 'Trainer Unmap Reasons',
    path: dataAnalyticsTitlesAndPath.TRAINER_UNMAPPED,
  },
  {
    title: 'Newly Assigned Tutors',
    path: dataAnalyticsTitlesAndPath.NEWLY_ASSIGNED_TUTORS,
  },
  {
    title: 'Active Tutors Across Each Subject',
    path: dataAnalyticsTitlesAndPath.ACTIVE_TUTORS_SUBJECT,
  },
  {
    title: 'Different TP Paid Tutors in a Month',
    path: dataAnalyticsTitlesAndPath.TP_PAID_TUTORS,
  },
  {
    title: 'Student Tutor Ratio',
    path: dataAnalyticsTitlesAndPath.STUDENT_TUTOR_RATIO,
  },
  {
    title: 'Tutor Change Data',
    path: dataAnalyticsTitlesAndPath.TUTOR_CHANGE_DATA,
  },
  {
    title: 'Inactive Tutors Data',
    path: dataAnalyticsTitlesAndPath.INACTIVE_TUTORS,
  },
  {
    title: 'Last Assigned TP of Tutors',
    path: dataAnalyticsTitlesAndPath.LAST_ASSIGNED_TP,
  },
  {
    title: 'Resigned Tutors Data',
    path: dataAnalyticsTitlesAndPath.RESIGNED_TUTORS,
  },
  {
    title: 'Course Enrollment Data',
    path: dataAnalyticsTitlesAndPath.COURSE_ENROLLMENT,
  },
  {
    title: 'Active Student Data',
    path: dataAnalyticsTitlesAndPath.ACTIVE_STUDENTS,
  },
];
